import SurveilPatient from "./SurveilPatient";

export default SurveilPatient;
